export const defaultSearchState = {
  searchText: {
    __typename: 'searchText',
    search: '',
  },
};
